import styled from 'styled-components';

export const Image = styled.img`
  width: ${(props) => (props.size ? props.size : 20)}px;
`;

export const IconContainer = styled.span`
  
`;
